function importAll (r) {
    r.keys().forEach(r);
  }
  
  window.$ = $
  window.jQuery = $
  import 'jquery.scrollto'
  console.log('asd')
  import Rails from "@rails/ujs"
  Rails.start()
  
  import 'slick-carousel'
  import 'slick-carousel/slick/slick.css'
  import "jquery-colorbox"
  
  importAll(require.context('hochland/images', true))
  import 'normalize.css'
  import 'hochland/styles/hochland.sass'
  import 'scrolldepth/jquery.scrolldepth.min.js'